import { Collapse, Grid, Skeleton, Stack } from "@mui/material";
import { SubmissionStatus } from "generated-graphql/graphql";
import { Suspense } from "react";
import { SubmissionGeneratorStatusTile } from "./SubmissionGeneratorStatusTile";
import { SubmissionStateTile } from "./SubmissionStateTile";
import { SubmissionStatusTile } from "./SubmissionStatusTile";
import { WasteSubmissionsOverviewProvider } from "./WasteSubmissionsOverviewContext";

type SubmissionStatsOverviewProps = {
  isOpen: boolean;
  onStatusClick?: (status: SubmissionStatus) => void;
  selectedStatus?: SubmissionStatus | null;
  onStateClick?: (state: string) => void;
  selectedState?: string | null;
  onGeneratorStatusClick?: (status: string) => void;
  selectedGeneratorStatus?: string | null;
};

function StatsSkeleton() {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={280} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={280} />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Skeleton variant="rounded" height={280} />
      </Grid>
    </Grid>
  );
}

export function SubmissionStatsOverview({
  isOpen,
  onStatusClick,
  selectedStatus,
  onStateClick,
  selectedState,
  onGeneratorStatusClick,
  selectedGeneratorStatus,
}: SubmissionStatsOverviewProps) {
  return (
    <Collapse in={isOpen}>
      <Stack p={2} pb={0}>
        <Suspense fallback={<StatsSkeleton />}>
          <WasteSubmissionsOverviewProvider>
            <Grid container spacing={2}>
              {/* Status donut, Generator Status donut, State bar chart */}
              <SubmissionStatusTile
                size={{ xs: 12, md: 4 }}
                onStatusClick={onStatusClick}
                selectedStatus={selectedStatus}
              />
              <SubmissionGeneratorStatusTile
                size={{ xs: 12, md: 4 }}
                onGeneratorStatusClick={onGeneratorStatusClick}
                selectedGeneratorStatus={selectedGeneratorStatus}
              />
              <SubmissionStateTile
                size={{ xs: 12, md: 4 }}
                onStateClick={onStateClick}
                selectedState={selectedState}
              />
            </Grid>
          </WasteSubmissionsOverviewProvider>
        </Suspense>
      </Stack>
    </Collapse>
  );
}

export { SubmissionGeneratorStatusTile } from "./SubmissionGeneratorStatusTile";
export { SubmissionStateTile } from "./SubmissionStateTile";
export { SubmissionStatusTile } from "./SubmissionStatusTile";
